
import { useContext, useState, useEffect, useRef } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  FaHandPointLeft,
  FaHandPointRight,
  FaLayerGroup,
  FaSignOutAlt,
  FaChevronDown,
} from "react-icons/fa";
import { MdDashboard } from "react-icons/md";
import SidebarDropdown from "./SidebarDropdown";
import { LuNotebookPen } from "react-icons/lu";
import { FaSquarePollHorizontal } from "react-icons/fa6";
import { BiSolidUserAccount } from "react-icons/bi";
import { IoMdSettings } from "react-icons/io";
import { CommonContext } from "../../App";
import axios from "axios";
import toast from "react-hot-toast";
import { useAuth } from "../Login/AuthContext";
import LoadingSpinner from "../CommonComponent/loadingSpiner/LoadingSpinner";
import { useTranslation } from "react-i18next";
import { TbBrandBinance } from "react-icons/tb";
import { MdOutlineManageHistory } from "react-icons/md";
import { TbReport } from "react-icons/tb";
import image from '../../assets/logo.png'
import api from "../../services/api";
import { useMemo } from "react";
import CancelButton from "../CommonComponent/Button/CancelButton";
import SaveButton from "../CommonComponent/Button/SaveButton";
const Sidebar = ({ collapsed, setCollapsed }) => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [branches, setBranches] = useState([]);
  const [selectedBranchId, setSelectedBranchId] = useState(null);
  const { userData, setBranch, setBranchId, setBranchExpireMSG } = useContext(CommonContext);
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const { t } = useTranslation();
  const dropdownRef = useRef(null);
  // ✅ Responsive behavior states
  const [isHovered, setIsHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
  // const [branchExpiry, setBranchExpiry] = useState(false); 
  // Detect screen resize for responsive sidebar
  useEffect(() => {
    if (selectedBranchId === "all") {
      navigate("/");
    }
  }, [selectedBranchId])

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 1442;
      setIsMobile(mobile);
      if (mobile) {
        setOpenDropdown(null)
        setCollapsed(true); // auto collapse on smaller screens
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  let branchesId = userData.user.branches;

  if (typeof branchesId === "string") {
    try {
      branchesId = JSON.parse(branchesId);
    } catch {
      branchesId = [];
    }
  }
  useEffect(() => {
    const fetchBranches = async () => {
      if (!userData?.user) return;
      try {
        let data;
        if (userData.user.role === "admin") {
          const result = await api.get(`branch/get-all/${userData.user.id}`);
          data = result.data;
        } else if (branchesId?.length > 0) {
          const ids = branchesId.join(",");
          const result = await api.get(`branch/by-id?id=${ids}`);
          data = result.data;
        } else {
          toast.error("No branches assigned to this user.");
          return;
        }

        if (data.success && data.branches?.length > 0) {
          setBranches(data.branches);
          //  handlecheckExpireDate(data.branches[0].expiry_date)
          const storedBranchId = localStorage.getItem("selectedBranchId");
          if (storedBranchId === "all" && userData.user.role === "admin") {
            const allBranchIds = data.branches.map((b) => b.id);
            const joinedIds = allBranchIds.join(",");
            
            setSelectedBranchId("all");
            setBranch(allBranchIds);
            setBranchId(joinedIds);
            setBranchExpireMSG(false);
          } else {
            const defaultId = storedBranchId
              ? parseInt(storedBranchId)
              : data.branches[0]?.id;
            setSelectedBranchId(defaultId);
            setBranch(defaultId);
            setBranchId(defaultId);
            checkExpiryByBranchId(defaultId, data.branches);
          }
        }
      } catch (err) {
        console.error("Error fetching branches:", err);
      }
    };

    fetchBranches();
  }, [userData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenDropdown(null);   // Close dropdown
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const handleBranchChange = (e) => {
    const newBranchId = parseInt(e.target.value);
    setSelectedBranchId(newBranchId);
    setBranch(newBranchId);
    setBranchId(newBranchId);
    localStorage.setItem("selectedBranchId", newBranchId);
  };
  const checkExpiryByBranchId = (branchId, branches) => {
    if (!branchId || branchId === "all") {
      setBranchExpireMSG(false);
      return;
    }

    const branch = branches.find(b => b.id === Number(branchId));
    if (branch?.expiry_date) {
      handlecheckExpireDate(branch.expiry_date, branch.name);
    }
  };

  const handlecheckExpireDate = (e, name) => {
    const currentDate = new Date();
    const expiryDate = new Date(e);
    if (currentDate > expiryDate) {
      toast.error(` The subscription of ${name} has expired.`)
      setBranchExpireMSG(true);
    } else {
      setBranchExpireMSG(false);
    }
  };

  const handleLogout = () => {
    setOpenLogoutModal(true);
  };

  const confirmLogout = async () => {
    setIsLoggingOut(true);
    try {
      await logout();
      navigate("/login", { replace: true });
      localStorage.removeItem("selectedBranchId");
      setBranch(null);
     setBranchId(null);
    } catch (err) {
      toast.error("Logout failed");
      console.error("Logout error:", err);
    } finally {
      setIsLoggingOut(false);
    }
  };

  const rights = useMemo(() => {
    try {
      if (!userData?.user?.rights || userData?.user?.rights === "undefined") {
        return [];
      }

      // Agar already array ho
      if (Array.isArray(userData?.user?.rights)) {
        return userData?.user?.rights;
      }

      return JSON.parse(userData?.user?.rights);
    } catch (error) {
      console.error("Invalid rights format:", userData?.rights);
      return [];
    }
  }, [userData]);


  const hasRight = (right) => {
    return rights.includes(right);
  };



  return (
    <>
      <div
        className={`${collapsed ? "w-14 mt-2 rounded-t p-2" : "w-40 xl:w-48 p-2 mt-2  rounded-t"
          } h-screen bg-theme-sidebarBg    fixed top-0 transition-all duration-200 ease-in-out z-[99] flex flex-col justify-between
        `}

      >

        <div>
          <div className="flex justify-between items-center my-1 relative">
            {!collapsed && (
              <div className="text-xl mt-[3px] font-arial font-bold  text-theme-color tracking-widest">
                <img src={image} width={100} alt="zilito" />
              </div>

            )}

            <button
              onClick={() => setCollapsed(!collapsed)}
              className={`${collapsed
                ? "left-0.4 me-1 mt-[28px]"
                : "top-[-3px]  right-0 "
                }    absolute py-2 px-[9.5px]  border-1 border-theme-sidebarBg outline-none hover:text-theme-sidebarBg  hover:border-white text-white rounded`}
            >
              {collapsed ? (
                <FaHandPointRight size={18} />
              ) : (
                <FaHandPointLeft size={18} />
              )}
            </button>

          </div>

          <div ref={dropdownRef} className={`${collapsed ? "mt-4" : "mt-0 mb-2"} relative mt-3 `}>
            {collapsed ? (
              <div className="border-1 border-theme-sidebarTabBg text-theme-color hover:bg-theme-sidebarTabBg hover:text-theme-sidebarBg mt-10 flex justify-center items-center p-2 rounded-1" ><TbBrandBinance /> </div>) : (
              <>
                {branches.length === 1 ? (
                  <div >

                    <div className="border-1 text-sm  border-theme-sidebarTabBg capitalize text-theme-color  px-2 py-[5px] rounded-1 font-medium">
                      {!isMobile ? branches[0].name.length > 20
                        ? branches[0].name.slice(0, 20) + "..."
                        : branches[0].name
                        : branches[0].name.length > 18
                          ? branches[0].name.slice(0, 18) + "..."
                          : branches[0].name
                      }
                    </div>
                  </div>
                ) : (
                  <div>
                    <div
                      className="border-1 border-theme-sidebarTabBg text-theme-color  mt-[10px] px-2 py-[5px] rounded-1 cursor-pointer text-sm flex justify-between items-center capitalize"
                      onClick={() =>
                        setOpenDropdown(openDropdown === "branch" ? null : "branch")
                      }
                    >
                      {(() => {
                        if (selectedBranchId === "all") {

                          return t("allBranches");
                        }
                        const selectedBranch = branches.find(
                          (b) => b.id === selectedBranchId
                        );
                        const name = selectedBranch?.name || branches[0]?.name;
                        return !isMobile ? (name && name.length > 18
                          ? name.slice(0, 18) + "..."
                          : name) : (name && name.length > 15
                            ? name.slice(0, 15) + "..."
                            : name)
                      })()}
                      <FaChevronDown
                        className={`transition-transform mt-[3px] text-[13px] duration-300 ${openDropdown === "branch" ? "rotate-180" : ""
                          }`}
                      />
                    </div>

                    {openDropdown === "branch" && (
                      <ul className="absolute left-0 right-0 mt-1 p-0 bg-white border border-gray-300 text-sm rounded shadow-md z-50 max-h-48 overflow-y-auto">
                        {userData?.user?.role === "admin" && (
                          <li
                            className={`px-2 py-1 text-sm cursor-pointer hover:bg-theme-dropdownHeqadibg hover:text-theme-color capitalize ${selectedBranchId === "all"
                              ? "bg-theme-headerBg text-theme-color "
                              : ""
                              }`}
                            onClick={() => {
                              const allBranchIds = branches.map((b) => b.id);
                              const joinedIds = allBranchIds.join(",");
                              setSelectedBranchId("all");
                             
                              setBranchId(joinedIds);
                              setBranch(allBranchIds);
                              localStorage.setItem("selectedBranchId", "all");
                              setOpenDropdown(null);
                            }}
                          >
                            <div>{t("allBranches")}</div>
                          </li>
                        )}

                        {branches.map((branch) => (
                          <li
                            key={branch.id}
                            className={`px-2 py-1 cursor-pointer hover:bg-theme-dropdownHeqadibg hover:text-theme-color capitalize text-sm ${selectedBranchId === branch.id
                              ? "bg-theme-headerBg text-theme-color "
                              : ""
                              }`}
                            onClick={() => {
                              setSelectedBranchId(branch.id);
                              handlecheckExpireDate(branch.expiry_date, branch.name)
                              setBranch(branch.id);
                              setBranchId(branch.id);
                              localStorage.setItem("selectedBranchId", branch.id);
                              setOpenDropdown(null);

                            }}
                          >
                            {/* {branch.name} */}
                            {/* { branch.name && branch.name.length > 22
                          ? branch.name.slice(0, 22) + "..."
                          : branch.name} */}
                            {!isMobile ? (branch.name && branch.name.length > 21
                              ? branch.name.slice(0, 21) + "..."
                              : branch.name) : (branch.name && branch.name.length > 17
                                ? branch.name.slice(0, 17) + "..."
                                : branch.name)}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                )}
              </>
            )}

          </div>



          <ul
            className={`${collapsed ? "mt-2" : "mt-0"} space-y-1 w-full p-0  text-white`}
          >

            {(userData.user.role === "admin" || hasRight("dashboard")) && (<li title={t('dashboard')}>
              <NavLink
                to="/"
                className={({ isActive }) =>
                  `block w-full no-underline text-sm  ${collapsed ? " flex justify-center py-[7px] " : "px-[6px] py-[5px] "} rounded-1 transition-colors duration-1000 ` +
                  (isActive
                    ? "bg-theme-sidebarTabBg text-theme-sidebarBg font-medium"
                    : "bg-transparent  text-theme-color font-medium")
                }
                onClick={() => setOpenDropdown(null)}
              >
                {collapsed ? <MdDashboard className="text-[17px]" /> : (t('dashboard'))}
              </NavLink>
            </li>)}
            {/* {(userData.user.role === "admin" || hasRight("day_book")) && (
              <li title={t('dayBook')}>
              <NavLink
                to="/daily-reports"
                className={({ isActive }) =>
                  `block w-full no-underline text-sm  ${collapsed ? " flex justify-center py-[7px] " : "px-[6px] py-[5px] "} rounded-1 transition-colors duration-1000 ` +
                  (isActive
                    ? "bg-theme-sidebarTabBg text-theme-sidebarBg font-medium"
                    : "bg-transparent  text-theme-color font-medium")
                }
                onClick={() => setOpenDropdown(null)}
              >
                {collapsed ? <TbReport className="text-[18px]" /> : (t('dayBook'))}
              </NavLink>
            </li>)} */}
              {(userData.user.role === "admin" || hasRight("day_book")) && (
              <li title={t('dayBook')}>
                {selectedBranchId === "all" ? (
                  <div
                    className="block w-full text-sm px-3 py-[5px] rounded-1 bg-transparent text-gray-400 cursor-not-allowed opacity-50"
                    title="Not available when All Branches is selected"
                  >
                    {collapsed ? <TbReport className="text-[17px]" /> : (t('dayBook'))}
                  </div>
                ) : (
                  <NavLink
                    to="/daily-reports"
                    className={({ isActive }) =>
                      `block w-full no-underline text-sm ${collapsed ? " flex justify-center py-[7px] " : "px-[6px] py-[5px] "}  rounded-1 transition-colors duration-1000 ` +
                      (isActive
                        ? "bg-theme-sidebarTabBg text-theme-sidebarBg font-medium"
                        : "bg-transparent  text-theme-color font-medium")
                    }
                    onClick={() => setOpenDropdown(null)}
                  >
                    {collapsed ? <TbReport className="text-[17px]" /> : (t('dayBook'))}
                  </NavLink>
                )}
              </li>)}

            {/* Register - Disabled when All Branches selected */}
            {(userData.user.role === "admin" || hasRight("entry")) && (
              <li title={t('register')}>
                {selectedBranchId === "all" ? (
                  <div
                    className="block w-full text-sm px-3 py-[5px] rounded-1 bg-transparent text-gray-400 cursor-not-allowed opacity-50"
                    title="Not available when All Branches is selected"
                  >
                    {collapsed ? <LuNotebookPen className="text-[17px]" /> : (t('register'))}
                  </div>
                ) : (
                  <NavLink
                    to="/dashboard"
                    className={({ isActive }) =>
                      `block w-full no-underline text-sm ${collapsed ? " flex justify-center py-[7px] " : "px-[6px] py-[5px] "}  rounded-1 transition-colors duration-1000 ` +
                      (isActive
                        ? "bg-theme-sidebarTabBg text-theme-sidebarBg font-medium"
                        : "bg-transparent  text-theme-color font-medium")
                    }
                    onClick={() => setOpenDropdown(null)}
                  >
                    {collapsed ? <LuNotebookPen className="text-[17px]" /> : (t('register'))}
                  </NavLink>
                )}
              </li>)}

            {/* Types & Groups - Disabled when All Branches selected */}
            {/* <li title={t('type&Group')}>
              {selectedBranchId === "all" ? (
                <div
                  className={`block w-full font-medium ${collapsed ? " flex justify-center" : "px-3"} py-2 rounded bg-transparent text-gray-400 cursor-not-allowed opacity-50`}
                  title="Not available when All Branches is selected"
                >
                  {collapsed ? <FaLayerGroup /> : (t('type&Group'))}
                </div>
              ) : (
                <NavLink
                  to="/types-groups"
                  className={({ isActive }) =>
                    `block w-full no-underline font-medium ${collapsed ? " flex justify-center" : "px-3"} py-2 rounded transition-colors duration-1000 ` +
                    (isActive
                      ? "bg-theme-color text-theme-bg"
                      : "bg-transparent  text-white")
                  }
                  onClick={() => setOpenDropdown(null)}
                >
                  {collapsed ? <FaLayerGroup /> : (t('type&Group'))}
                </NavLink>
              )}
            </li> */}

            {/* Ledger/Accounts Dropdown - Disabled when All Branches selected */}
            {(userData.user.role === "admin" || hasRight("account_book")) && (
              <li title={t('accountBooks')}>
                {selectedBranchId === "all" ? (
                  <div
                    className="block w-full text-sm px-[6px] py-[5px] rounded-1 bg-transparent text-gray-400 cursor-not-allowed opacity-50"
                    title="Not available when All Branches is selected"
                  >
                    <div className="flex w-full justify-between items-center">
                      {collapsed ? <div className=" w-full py-2 rounded-1 flex justify-center"><BiSolidUserAccount className="text-[17px]" /></div> : (t('accountBooks'))}
                      {/* {!collapsed && <FaChevronDown className="text-[17px]" />} */}
                    </div>
                  </div>
                ) : (
                  <>
                    <NavLink
                      to="/account-books"
                      // state={{ typeName: "Assets" }} 
                      className={({ isActive }) =>
                        "block w-full no-underline text-sm  rounded-1 transition-colors duration-1000 " +
                        (isActive
                          ? "bg-theme-sidebarTabBg text-theme-sidebarBg font-medium"
                          : "bg-transparent  text-theme-color font-medium")
                      }
                    >
                      <button
                        // onClick={() =>
                        //   setOpenDropdown(openDropdown === "ledger" ? null : "ledger")
                        // }
                        className={`flex w-full justify-between items-center ${!collapsed && "py-[5px] px-[6px]"}   rounded-1 text-sm `}
                      >
                        {collapsed ? <div className=" w-full py-2 rounded flex justify-center"><BiSolidUserAccount className="text-[17px]" /></div> : (t('accountBooks'))}
                        {/* {!collapsed && (
                        <span
                          className={`transform transition-transform duration-300 ${openDropdown === "ledger" ? "rotate-180" : ""
                            }`}
                        >
                          <FaChevronDown />
                        </span>
                      )} */}
                      </button>
                    </NavLink>

                    {/* <div
                    className={`mr-2 mt-1 overflow-hidden transition-all duration-300 ${openDropdown === "ledger" ? "max-h-[1000px]" : "max-h-0"
                      }`}
                  >
                    <SidebarDropdown collapsed={collapsed} />
                  </div> */}
                  </>
                )}
              </li>)}
            {(userData.user.role === "admin" || hasRight("inventory_book")) && (<li title={t('inventoryBooks')}>
              <NavLink
                to="/inventory-books"
                className={({ isActive }) =>
                  `block w-full no-underline text-sm ${collapsed ? " flex justify-center py-[7px] " : "px-[6px] py-[5px] "} rounded-1 transition-colors duration-1000 ` +
                  (isActive
                    ? "bg-theme-sidebarTabBg text-theme-sidebarBg font-medium"
                    : "bg-transparent  text-theme-color font-medium")
                }
                onClick={() => setOpenDropdown(null)}
              >
                {collapsed ? <MdOutlineManageHistory className="text-[17px]" /> : (t('inventoryBooks'))}
              </NavLink>
            </li>)}

            {/* Reports - Always enabled */}
            {(userData.user.role === "admin" || hasRight("reports")) && (<li title={t('reports')}>
              <NavLink
                to="/reports"
                className={({ isActive }) =>
                  `block w-full no-underline text-sm ${collapsed ? " flex justify-center py-[7px] " : "px-[6px] py-[5px] "}  rounded-1 transition-colors duration-1000 ` +
                  (isActive
                    ? "bg-theme-sidebarTabBg text-theme-sidebarBg font-medium"
                    : "bg-transparent  text-theme-color font-medium")
                }
                onClick={() => setOpenDropdown(null)}
              >
                {collapsed ? <FaSquarePollHorizontal className="text-[17px]" /> : (t('reports'))}
              </NavLink>
            </li>)}


            {/* Settings - Always enabled for admin */}
            {(
              <li title={t('setting')}>
                <NavLink
                  to="/web-setting"
                  className={({ isActive }) =>
                    `block w-full no-underline text-sm ${collapsed ? " flex justify-center py-[7px] " : "px-[6px] py-[5px] "} rounded-1 transition-colors duration-1000 ` +
                    (isActive
                      ? "bg-theme-sidebarTabBg text-theme-sidebarBg font-medium"
                      : "bg-transparent  text-theme-color font-medium")
                  }
                  onClick={() => setOpenDropdown(null)}
                >
                  {collapsed ? <IoMdSettings className="text-[17px]" /> : (t('setting'))}
                </NavLink>
              </li>
            )}
          </ul>

        </div>

        {/* === Logout === */}
        <div className="flex justify-between items-center  pt-2 mt-auto relative border-t">
          {collapsed ?
            <div className="text-theme-sidebarBg  mb-2 w-full flex justify-center bg-theme-sidebarTabBg hover:text-theme-sidebarBg hover:bg-theme-sidebarTabBg rounded py-2 cursor-pointer" onClick={handleLogout}><FaSignOutAlt /></div> : (
              <h5
                className="flex text-theme-sidebarTabBg hover:bg-theme-sidebarTabBg gap-2 ps-2 cursor-pointer py-[5px] rounded-1 font-medium text-sm  hover:text-theme-sidebarBg  w-full"
                onClick={handleLogout}
              >

                <FaSignOutAlt className="mt-[3px] " /> {t("logout")}
              </h5>
            )}
        </div>
      </div>

      {/* === Logout Modal === */}
      {openLogoutModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/30 z-[1000]">
          <div className="bg-theme-sidebarTabBg text-theme-sidebarBg rounded-lg p-2 w-96 shadow-lg relative text-center">
            <div className="py-[4px] font-semibold mb-2 bg-theme-headerBg text-theme-color rounded-1 ">{t("logoutConfirm")}</div>
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTr3jhpAFYpzxx39DRuXIYxNPXc0zI5F6IiMQ&s"
              alt="User"
              className="w-16 h-16 rounded-full mx-auto mb-1 border"
            />
            <div className=" text-theme-headerBg fw-bold capitalize">{user.role}</div>
            <div className="text-gray-600 fw-bold capitalize ">
              {user.first_name + " " + user.last_name}
            </div>
            <div className="text-gray-500 text-sm mb-4">{user.email}</div>

            <div className="flex justify-center gap-2 mb-2">

              <CancelButton onClick={() => setOpenLogoutModal(false)} text={t('cancel')} />

              <SaveButton onClick={confirmLogout} text={t('logout')} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;







